import { ref } from 'firebase/database';
import { database } from 'config/firebase';

/**
 * Creates a Firebase database reference.
 *
 * Paths are identical in every environment. Dev used to prefix a
 * 'birreria-el-semaforo/' namespace because it shared one Firebase project with
 * other Transpiled apps; since #462 it has its own project, so the namespace is
 * gone and dev and production have the same shape. Keeping this helper (rather
 * than calling ref() directly at ~101 call sites) preserves the single seam where
 * path handling lives.
 *
 * @param {string} path - The database path (e.g., 'menus/latest', '/siteInfo/remoteMenuEnabled')
 * @returns {DatabaseReference} Firebase database reference
 *
 * @example
 * const menuRef = dbRef('menus/latest');   // -> menus/latest
 */
export const dbRef = (path) => {
  // Leading slash is optional at call sites; normalize it away.
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;

  // An empty path means the database root — AdminContext relies on this for
  // multi-path update() calls.
  return cleanPath ? ref(database, cleanPath) : ref(database);
};
